export enum CADASTRAL_DATA_MATCHING_LIST_FILTERS {
  SEARCH = 'search',
  STATUS = 'status',
  CREATED_AT_MIN = 'createdAtMin',
}

export enum CADASTRAL_DATA_MATCHING_STATUS {
  NOT_INITIALIZED = 'not-initialized',
  IN_PROCESS = 'in-process',
  PROCESS_ERROR = 'process-error',
  PROCESS_PROVIDER_ERROR = 'process-provider-error',
  PROCESSED = 'processed',
  REJECTED = 'rejected',
}

export enum CADASTRAL_DATA_MATCHING_COLUMNS {
  FILE_NAME = 'file-name',
  STATUS = 'status',
  UPLOADED_AT = 'uploaded-at',
  CREATED_AT = 'created-at',
}

export enum CADASTRAL_DATA_MATCHING_LIST_ACTIONS {
  DETAILS = 'details',
  DOWNLOAD = 'download',
}

export enum CADASTRAL_DATA_MATCHING_UPLOAD_STEPS {
  FORM = 'form',
  SUCCESS = 'success',
  ERROR = 'error',
}

export enum CADASTRAL_DATA_MATCHING_PERMISSIONS {
  CREATE = 'cadastral-data-matching:create',
}
